import React from "react";
import "./LegalNotice.css";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import axios from 'axios';

const Documents = () => {
  const { t } = useTranslation();

  document.title = t("page-title.documents");

  const [obrazci, setObrazci] = React.useState([]);
  const [pogoji, setPogoji] = React.useState([]);
  const [ugodnosti, setUgodnosti] = React.useState([]);
  const [obvestila, setObvestila] = React.useState([]);

  const [moonpogoji, setMoonPogoji] = React.useState([]);
  const [moonceniki, setMoonCeniki] = React.useState([]);

  const [ceniki, setCeniki] = React.useState([]);

  const [loading, setLoading] = React.useState(true);

  const apiUrl = 'https://docs.ngen-group.eu/api/';

  React.useEffect(() => {
    const config1 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: apiUrl + 'documents?lang=sl',
      headers: {
        'Authorization': 'Bearer jmLIFRUUGy9y7TmI7EfTBMmkYRt6YVajU0iLZMM7e9d64afa'
      }
    };
    const config2 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: apiUrl + 'pricelists?lang=sl',
      headers: {
        'Authorization': 'Bearer jmLIFRUUGy9y7TmI7EfTBMmkYRt6YVajU0iLZMM7e9d64afa'
      }
    };
    Promise.all([axios.request(config1), axios.request(config2)])
      .then(([response1, response2]) => {
        const allDocuments = response1.data;
        const allPricelists = response2.data;

        const obrazci = allDocuments.filter(doc => doc.lang === 'sl' && doc.type === 'obrazci' && doc.company === 'ngg');
        setObrazci(obrazci);

        const pogoji = allDocuments.filter(doc => doc.lang === 'sl' && doc.type === 'splosni_pogoji' && doc.company === 'ngg');
        setPogoji(pogoji);

        const ugodnosti = allDocuments.filter(doc => doc.lang === 'sl' && doc.type === 'ugodnosti' && doc.company === 'ngg');
        setUgodnosti(ugodnosti);

        const obvestila = allDocuments.filter(doc => doc.lang === 'sl' && doc.type === 'obvestila' && doc.company === 'ngg');
        setObvestila(obvestila);

        const ceniki = allPricelists.filter(doc => doc.lang === 'sl' && doc.company === 'ngg');
        setCeniki(ceniki);

        const moonpogoji = allDocuments.filter(doc => doc.lang === 'sl' && doc.type === 'splosni_pogoji' && doc.company === 'moe');
        setMoonPogoji(moonpogoji);

        const moonceniki = allPricelists.filter(doc => doc.lang === 'sl' && doc.lang === 'sl' && doc.company === 'moe');
        setMoonCeniki(moonceniki);

        setLoading(false);

      })
      .catch(error => {
        console.error('Error fetching documents:', error);
      });

  }, []);


  return (
    <div className="UILegalNotice">
      <div className="container-fluid background">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-7">
              <div className="heading">
                <h1>{t("pages.documents")}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!loading && (
      <div className="container content">
        <div className="text documents">
          <p>{t("documents.docs2")}</p>
          <ul>
            {obrazci.map((doc, index) => (
              <li key={index}>
                <a target="_blank" href={'https://' + doc.url}>
                  {doc.name}
                </a>
              </li>
            ))}
          </ul>

          <p>{t("documents.docs4")}</p>
          <ul>
            {obvestila.map((doc, index) => (
              <li key={index}>
                <a target="_blank" href={'https://' + doc.url}>
                  {doc.name}
                </a>
              </li>
            ))}
          </ul>
          <p>{t("documents.docs5")}</p>
          <ul>
            {ugodnosti.map((doc, index) => (
              <li key={index}>
                <a target="_blank" href={'https://' + doc.url}>
                  {doc.name}
                </a>
              </li>
            ))}
          </ul>
          <br />
          <h2>Ngen</h2>
          <p>{t("documents.docs1")}</p>
          <ul>
            {pogoji.map((doc, index) => (
              <li key={index}>
                <a target="_blank" href={'https://' + doc.url}>
                  {doc.name}
                </a><span> - {doc.valid}</span>
              </li>
            ))}
          </ul>
          <p>{t("documents.docs3")}</p>
          <ul>

          {ceniki.map((doc, index) => (
              <li key={index}>
                <a target="_blank" href={'https://' + doc.url}>
                  {doc.name}
                </a><span> - {doc.valid}</span>
              </li>
            ))}
          </ul>
          <br />
          <h2>MOONelektrika</h2>

          <p>{t("documents.docs1")}</p>
          <ul>
            {moonpogoji.map((doc, index) => (
              <li key={index}>
                <a target="_blank" href={'https://' + doc.url}>
                  {doc.name}
                </a>
              </li>
            ))}
          </ul>
          <p>{t("documents.docs3")}</p>
          <ul>
            {moonceniki.map((doc, index) => (
              <li key={index}>
                <a target="_blank" href={'https://' + doc.url}>
                  {doc.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      )}
    </div>
  );
};

export default Documents;
